module.exports = __webpack_public_path__ + "img/money-cny-circle-line.583b741c.svg";